export const BASE_CLOUDINARY_URL =
  'http://res.cloudinary.com/solin-fitness/image/upload/';

export const cloudinaryUrl = (
  publicId: string,
  quality: string,
  fetchFormat = true,
  crop: string | undefined = undefined,
  width: number | undefined = undefined,
  height: number | undefined = undefined,
): string => {
  let url = BASE_CLOUDINARY_URL;
  url = url + (crop ? `${crop},` : '');
  url = url + `q_${quality}`;
  url = url + (fetchFormat ? ',f_auto' : '');
  url = url + (width ? `,w_${width}` : '');
  url = url + (height ? `,w_${height}` : '');
  url = url + `/${publicId}`;

  return url;
};
